import React, { useContext } from 'react';
import compact from 'lodash/compact';
import Subscription from '../models/Subscription'
import { EnrollmentsContext } from './yolk/Enrollments'
import { LineItemsContext } from './LineItems'
import { LineItemsExtensionContext } from './LineItemsExtension'
import { OfficeHourSubscriptionsContext } from './OfficeHourSubscriptions'
import { UserContext } from './yolk/User'
import { OfficeHoursContext } from './OfficeHours'

const SubscriptionsContext = React.createContext();

const SubscriptionsProvider = (props) => {
  const lineItems = useContext(LineItemsContext)
  const lineItemsExtension = useContext(LineItemsExtensionContext)
  const [enrollments] = useContext(EnrollmentsContext)
  const [user] = useContext(UserContext)
  const officeHourSubscriptions = useContext(OfficeHourSubscriptionsContext)

  const enrollmentsDupe = [].concat(enrollments)

  let subscriptionCountWithoutEnrollment = 0
  let subscriptionCountWithoutLineItem = 0
  let subscriptionCountWithPlan = 0

  let subscriptions = compact(lineItems.map((lineItem) => {
    try {
      const enrollment = enrollmentsDupe.find((enrollment) => {
        return lineItem.matches(enrollment)
      })

      if (!enrollment) {
        subscriptionCountWithoutEnrollment++
      } else {
        // remove enrollments from array
        enrollmentsDupe.splice(enrollmentsDupe.indexOf(enrollment), 1)
      }
      return Subscription(lineItem, enrollment)
    } catch(error) {
      console.error(`error creating subscription from lineItem : ${JSON.stringify(lineItem)}`, error)
    }
  }))

  // don't create subscriptions for OH enrollments
  officeHourSubscriptions.forEach((officeHourSubscription) => {
    const index = enrollmentsDupe.indexOf(officeHourSubscription.enrollment)
    if (index >= 0) {
      enrollmentsDupe.splice(index, 1)
    }
  })

  // add enrollments not assigned to lineItems to subscriptions
  enrollmentsDupe.forEach((enrollment) => {
    try {
      subscriptionCountWithoutLineItem++
      subscriptions.push(Subscription(null, enrollment))
    } catch(error) {
      console.error(`error creating subscription from enrollment : ${JSON.stringify(enrollment)}`, error)
    }
  })

  // shopper#180 : hide temp registrations if full sub is present
  subscriptions = subscriptions.filter((subscription) => {
    if (subscription.isTemp) {
      const fullSub = subscriptions.find((s) => s.sectionId == subscription.sectionId && !s.isTemp)
      if (fullSub) {
        console.log(`${subscription.id} : hiding temp subscription as full sub is present ${fullSub.id}`)
      }
      return !fullSub
    }
    return true
  })

  // shopper#829 : hide if purchased order belongs to other user
  subscriptions = subscriptions.filter((subscription) => {
    if (!!subscription.enrollment && !subscription.belongsTo(user.username)) {
      console.log(`${subscription.id} : hiding subscription as has been moved to other user`)
      return false
    }
    return true
  })

  // shopper#187 : sort subscriptions by status and end_at
  subscriptions.sort((a, b) => {
    if (!a.enrollmentId && !!b.enrollmentId) {
      return -1
    }
    if (!!a.enrollmentId && !b.enrollmentId) {
      return 1
    }
    if (!a.enrollmentId && !b.enrollmentId) {
      return 0
    }

    if (a.status == 'ready' && b.status != 'ready') {
      return -1
    }
    if (a.status != 'ready' && b.status == 'ready') {
      return 1
    }

    if (a.status == 'delayed_start' && b.status != 'delayed_start') {
      return -1
    }
    if (a.status != 'delayed_start' && b.status == 'delayed_start') {
      return 1
    }

    return new Date(b.endAt) - new Date(a.endAt)
  })
  console.log(`${subscriptions.length} subscriptions from ${lineItems.length} lineItems ${subscriptionCountWithoutEnrollment ? '(' + subscriptionCountWithoutEnrollment + ' without enrollment)' : ''} and ${enrollments.length} enrollments ${subscriptionCountWithoutLineItem ? '(' + subscriptionCountWithoutLineItem + ' without lineItem)' : ''} and ${officeHourSubscriptions.length} office hours`)
  props.onSubscriptions && props.onSubscriptions(subscriptions)

  return (
    <SubscriptionsContext.Provider value={subscriptions}>
      {props.children}
    </SubscriptionsContext.Provider>
  );
};

export { SubscriptionsContext, SubscriptionsProvider}
